import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as CalendarState from '../../state/reducer/calendar/calendar';
import * as LibraryState from '../../state/reducer/library/library';

const useFullScreenWorkout = programWorkoutId => {
    const [session, setSession] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const loggedInUserId = useSelector(state => state.app.loggedInUser.id);

    useEffect(() => {
        LibraryState.loadExercises();
    }, []);

    useEffect(
        () => {
            setIsLoading(true);
            if (!loggedInUserId) {
                return;
            }

            CalendarState.loadSessionPreviewForUser(
                programWorkoutId,
                loggedInUserId
            ).then(
                response => {
                    setSession(response.workout_preview);
                    setIsLoading(false);
                },
                error => {
                    console.error(error);
                    setIsLoading(false);
                }
            );
        },
        [programWorkoutId, loggedInUserId]
    );

    return { session, isLoading };
};

export default useFullScreenWorkout;



// WEBPACK FOOTER //
// ./src/view/fullScreenWorkout/useFullScreenWorkout.js